import { Link } from 'react-router';

export default function NotFoundPage() {
  return (
    <section className="page-gutter mx-auto max-w-(--container-page) py-24 md:py-36">
      <p className="label text-stamp-ink">Error 404</p>
      <h1 className="text-display-lg mt-6 max-w-[20ch]">This page is not on the shelf.</h1>
      <p className="text-read font-display text-ink-80 mt-6 max-w-(--container-prose)">
        The link may be old, or the book may have found a new home. Both happen here more than most
        places.
      </p>
      <div className="mt-10 flex flex-wrap items-center gap-x-10 gap-y-4">
        <Link
          to="/"
          className="label bg-ink text-paper hover:bg-stamp-ink px-6 py-3.5 no-underline transition-colors duration-200"
        >
          Back to the shop
        </Link>
        <Link to="/secondhand" className="label text-ink hover:text-stamp-ink">
          Browse secondhand &rarr;
        </Link>
      </div>
    </section>
  );
}
